import React from 'react';
import { InnerLayout, FillContainer } from '@layout';
import { Alt } from '@heading';
import Date from '@components/Date';
import { ArrowLink } from '@input';
import Excerpt from '@components/Excerpt';
import Pagination from '@components/Pagination';
import useWindowSize from '@hooks/useWindowSize';
import styles, { mobileImageWidth } from './Blog.module.scss';
import { Link } from 'gatsby';
import classNames from 'classnames';
import Img from 'gatsby-image';

export default function Blog({ data }) {
  const posts = data?.allMarkdownRemark?.edges;

  return (
    <InnerLayout h1="Lab Updates">
      {!posts?.length ? (
        <div className={styles.noPosts}>
          No recent updates, check again soon!
        </div>
      ) : (
        <React.Fragment>
          <div className={styles.content}>
            {posts.map(({ node }, index) => {
              const next = posts[index + 1];
              const nextHasImage = !!next?.node.frontmatter?.featuredimage;

              return (
                <Post
                  key={index}
                  nextHasImage={nextHasImage}
                  {...node}
                />
              );
            })}
          </div>
          <Pagination
            className={styles.pagination}
            prevText="Newer posts"
            nextText="Older posts"
          />
        </React.Fragment>
      )}
    </InnerLayout>
  );
}

function Post({
  fields,
  frontmatter,
  excerpt: truncatedContent = '',
  nextHasImage
}) {
  const { slug } = fields;
  const { title, date, excerpt, featuredimage } = frontmatter;
  const content = (excerpt || truncatedContent)?.trim();

  if (!title || !slug || !content) {
    return null;
  }

  return (
    <div
      className={classNames(styles.post, {
        [styles.hasImage]: !!featuredimage,
        [styles.nextHasImage]: nextHasImage
      })}
    >
      {featuredimage && (
        <FeaturedImage
          image={featuredimage}
          slug={slug}
        />
      )}
      <div className={styles.postContent}>
        <h2>
          <Link to={slug}>
            <Alt>{title}</Alt>
          </Link>
        </h2>
        <Date
          className={styles.date}
          value={date}
        />
        <Excerpt text={content} />
        <ArrowLink
          className={styles.link}
          to={slug}
        >
          Read more
        </ArrowLink>
      </div>
    </div>
  );
}

function FeaturedImage({ image, slug }) {
  const { width: windowWidth } = useWindowSize();
  const isDesktop = windowWidth > parseInt(mobileImageWidth);
  const props = {
    className: styles.image,
    fadeIn: false,
    alt: ''
  };

  if (isDesktop) {
    props.fixed = image.childImageSharp.desktop;
  } else {
    props.fluid = image.childImageSharp.mobile;
  }

  const content = (
    <Link
      to={slug}
      className={styles.imageWrapper}
    >
      <Img {...props} />
    </Link>
  );

  return (
    <React.Fragment>
      {isDesktop ? content : <FillContainer>{content}</FillContainer>}
    </React.Fragment>
  );
}
